import clsx from 'clsx';

import EditableField from '~components/generic/editable-field/EditableField/EditableField';
import { ModuleAttachments } from '~components/generic/module-attachments/ModuleAttachments';
import { ICrazyModuleContainerClassNamesConstruct, IEntityComponentProps } from '~interfaces/props';
import VideoContainer from '~modules/video/VideoContainer';
import { getFieldValue } from '~services/entity-helpers';
import { getModuleUrlIdFromData } from '~services/location-helpers';

const ModuleVideo = ({ data, editing, className, onChange }: IEntityComponentProps) => {
  if (!data) {
    return null;
  }

  return (
    <div className={clsx(className?.module)} id={getModuleUrlIdFromData(data.id, data.type)}>
      <div className={clsx(className?.container)}>
        <div className="row c-module__header">
          <div className="col col-12">
            <EditableField
              hide={getFieldValue<boolean>(data, 'attributes.field_hide_title')}
              entityType={data.type}
              fieldName="attributes.field_title.value"
              data={getFieldValue<string>(data, 'attributes.field_title.value')}
              editing={editing}
              onChange={onChange}
            />
          </div>
          <ModuleAttachments data={data} />
        </div>
        <div className="row d-flex flex-wrap c-module__content">
          {!data.attributes.field_hide_text && (
            <div className="col col-12 u-margin-top-sm">
              <div className="row">
                <div className="col col-md-8 o-field-text">
                  <EditableField
                    entityType={data.type}
                    fieldName="attributes.field_text.value"
                    data={getFieldValue<string>(data, 'attributes.field_text.value')}
                    editing={editing}
                    onChange={onChange}
                  />
                </div>
              </div>
            </div>
          )}
          <div className="col col-12 u-margin-top-md">
            <VideoContainer
              entityId={data.id}
              extraDataFieldNames={{
                webm: ['relationships.field_webm.data'],
                mpeg4: ['relationships.field_mpeg4.data'],
                poster: ['relationships.field_image.data'],
              }}
              preload="metadata"
              controls={true}
              className={'u-full-width' as unknown as ICrazyModuleContainerClassNamesConstruct}
            />
          </div>
          {!getFieldValue<boolean>(data, 'attributes.field_hide_caption') && (
            <div className="col col-12 o-field-text field--name-field-caption">
              <EditableField
                entityType={data.type}
                fieldName="attributes.field_caption.value"
                data={getFieldValue<string>(data, 'attributes.field_caption.value')}
                editing={editing}
                onChange={onChange}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModuleVideo;
